var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCLogoWhiteGreen = function SvgCLogoWhiteGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.924 17.135c-2.1-.693-3.171-2.92-3.182-5.901 0-2.982 1.176-6.468 4.757-6.468 2.32 0 3.769 1.081 4.126 3.36h5.46c-.262-3.812-2.709-6.174-5.88-7.161v-.01a.6.6 0 0 1-.147-.043 7 7 0 0 0-.231-.063c-.22-.063-.43-.115-.662-.168h-.01A12.7 12.7 0 0 0 10.53.408C3.926.408.156 5.081.156 11.412c0 5.576 3.465 9.66 8.757 10.311z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5DD39E",
    d: "M14.11 17.115v10.679h4.778v-5.88h5.88v-4.799z"
  })));
};
export default SvgCLogoWhiteGreen;